export const BASE_CURRENCY_CODE = "GBP";

export const CURRENCIES = {
  GBP: { code: "GBP", symbol: "£", locale: "en-GB" },
  USD: { code: "USD", symbol: "$", locale: "en-US" },
  EUR: { code: "EUR", symbol: "€", locale: "de-DE" },
  INR: { code: "INR", symbol: "₹", locale: "en-IN" },
  AUD: { code: "AUD", symbol: "A$", locale: "en-AU" },
  CAD: { code: "CAD", symbol: "C$", locale: "en-CA" },
};

export const DEFAULT_COUNTRY = "GB";

export const COUNTRY_CURRENCY = {
  GB: "GBP",
  IE: "EUR",
  US: "USD",
  IN: "INR",
  AU: "AUD",
  CA: "CAD",
  AT: "EUR",
  BE: "EUR",
  CY: "EUR",
  DE: "EUR",
  EE: "EUR",
  ES: "EUR",
  FI: "EUR",
  FR: "EUR",
  GR: "EUR",
  HR: "EUR",
  IT: "EUR",
  LT: "EUR",
  LU: "EUR",
  LV: "EUR",
  MT: "EUR",
  NL: "EUR",
  PT: "EUR",
  SI: "EUR",
  SK: "EUR",
};

export const TIMEZONE_COUNTRY = {
  "Europe/London": "GB",
  "Europe/Dublin": "IE",
  "America/New_York": "US",
  "America/Chicago": "US",
  "America/Denver": "US",
  "America/Los_Angeles": "US",
  "America/Phoenix": "US",
  "Asia/Kolkata": "IN",
  "Asia/Calcutta": "IN",
  "Australia/Sydney": "AU",
  "Australia/Melbourne": "AU",
  "America/Toronto": "CA",
  "America/Vancouver": "CA",
  "Europe/Paris": "FR",
  "Europe/Berlin": "DE",
  "Europe/Madrid": "ES",
  "Europe/Rome": "IT",
  "Europe/Amsterdam": "NL",
};

export const GEO_PROVIDERS = [
  {
    id: "country.is",
    url: "https://api.country.is/",
    type: "json",
  },
  {
    id: "geojs",
    url: "https://get.geojs.io/v1/ip/country.json",
    type: "json",
  },
  {
    id: "cloudflare",
    url: "https://www.cloudflare.com/cdn-cgi/trace",
    type: "text",
  },
];

export const FX_RATES_URL = "https://open.er-api.com/v6/latest/GBP";

export const fxRatesUrlForBase = (baseCurrencyCode) =>
  `https://open.er-api.com/v6/latest/${String(baseCurrencyCode || "GBP")
    .trim()
    .toUpperCase()}`;
